import request from '@/utils/request'

//今日统计
export const today_acount = (data) => {
    return request({
      url: '/erp-pos/statistics/today',
      method: 'post',
      data
    })
  }
  //日订单列表
  export const today_acount_detail = (data) => {
    return request({
      url: '/erp-pos/statistics/daliy-order-list',
      method: 'post',
      data
    })
  }
    //日实收统计
    export const today_acount_real = (data) => {
      return request({
        url: '/erp-pos/statistics/actual-collection',
        method: 'post',
        data
      })
    }